import fetchApi from "../fetchApi";
export const CreateOffice = async ({ company_id, name, status, address1, address2, postalCode, state, city, country }) => {
    const options = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify({
            "name": name,
            "company_id": company_id,
            "status": status,
            "address": address1,
            "address_additional": address2,
            "postal_code": postalCode,
            "state": state,
            "city": city,
            "country": country
        }),
        redirect: 'follow'
    };

    return await fetchApi(`offices`, options);
};
